<div class="container vh-100">
  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="d-flex justify-content-center align-items-center h-100 position-relative">
        
        <img class="set_image" src="/img/background_comming.png" alt="">

        <div class="containt_pos">
          <div class="row">
            
            <div class="col-xl-7 col-lg-7 col-md-12 my-3 order-last">
              <div class="text-center">
                <img class="mt-4 w-440" src="/img/pankhudiLogo2.png" alt="">
              </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-12 my-3">
              <div class="row">
                <div class="col-11 m-auto text-center">

                  <img src="/img/PankhudiLogo.png" alt="">

                  <h2 class="text_style mt-4">
                    Pankhudi Portal<br> Under Maintenance
                  </h2>

                  <p class="mb-0">
                    The <b>Pankhudi Portal</b> is currently undergoing scheduled
                    maintenance improve performance, security, and user experience.
                  </p>

                  <!-- <p class="mb-0">
                    The <b>Pankhudi Portal</b> is expected to be live on
                    13 February 2026 at 6:30 PM (IST).
                  </p> -->

                  <p class="mb-0">
                    Ministry of Women and Child Development | Pankhudi Portal
                  </p>

                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
